import { THEME_PREF_KEY } from '../theme.js';

// login pakai preferensi yang sama dengan aplikasi
export const THEME_KEY = THEME_PREF_KEY;

// apa pun yang gak dikenal jatuh ke terang, itu default paling aman
export function normalizeTheme(value) {
  return value === 'dark' ? 'dark' : 'light';
}

export function oppositeTheme(value) {
  return normalizeTheme(value) === 'dark' ? 'light' : 'dark';
}
